import { render, staticRenderFns } from "./topBPoint.vue?vue&type=template&id=3d4d7cee&scoped=true&"
import script from "./topBPoint.vue?vue&type=script&lang=js&"
export * from "./topBPoint.vue?vue&type=script&lang=js&"
import style0 from "./topBPoint.vue?vue&type=style&index=0&id=3d4d7cee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4d7cee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VImg,VRow})
